/*
  28/10/2026 : cartes des pages collection, sur téléphone et écrans tactiles.
  - On glisse dans la carte : l'œuvre, puis ses mises en situation (data-insitu, posé
    par main-collection-product-grid), bord à bord. Ni flèche ni indicateur.
  - Une seule fois par session, la 1re carte esquisse le mouvement : un rebond qui
    montre un tiers de la première mise en situation. Jamais avec « réduire les animations ».
  - Chargement : la 1re mise en situation quand la carte approche de l'écran,
    les suivantes au premier glisser. Rien de plus à l'arrivée sur la page.
  - Ordinateur avec souris : rien ne change, le survol reste.
*/
(function () {
  var touch = window.matchMedia('screen and (hover: none), screen and (max-width: 989px)');
  if (!touch.matches) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var HINT_KEY = 'mobe-card-swipe-hint';
  var hintPlayed = false;

  function hintSeen() {
    try {
      return sessionStorage.getItem(HINT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markHint() {
    try {
      sessionStorage.setItem(HINT_KEY, '1');
    } catch (e) {}
  }

  function load(img) {
    if (img && img.dataset.src && !img.getAttribute('src')) img.setAttribute('src', img.dataset.src);
    return img;
  }

  function build(item) {
    if (item.dataset.swipeReady) return item.querySelector('.mobe-swipe');
    var srcs = (item.dataset.insitu || '').split('|').filter(Boolean);
    var inner = item.querySelector('.card__inner');
    var media = inner && inner.querySelector('.card__media');
    var link = item.querySelector('.card__heading a[href]');
    if (!srcs.length || !inner || !media || !link) return null;
    item.dataset.swipeReady = '1';

    var href = link.getAttribute('href');
    var track = document.createElement('div');
    track.className = 'mobe-swipe';
    var rail = document.createElement('div');
    rail.className = 'mobe-swipe__rail';

    // 1re vue : le média d'origine de la carte, déplacé tel quel (cadre gris compris).
    var first = document.createElement('a');
    first.className = 'mobe-swipe__slide mobe-swipe__slide--artwork';
    first.href = href;
    first.tabIndex = -1;
    first.setAttribute('aria-hidden', 'true');
    first.appendChild(media);
    rail.appendChild(first);

    srcs.forEach(function (src) {
      var slide = document.createElement('a');
      slide.className = 'mobe-swipe__slide';
      slide.href = href;
      slide.tabIndex = -1;
      slide.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      img.dataset.src = src;
      slide.appendChild(img);
      rail.appendChild(slide);
    });

    track.appendChild(rail);
    inner.appendChild(track);
    item.classList.add('mobe-swipe-card');

    track.addEventListener(
      'scroll',
      function loadRest() {
        rail.querySelectorAll('img[data-src]').forEach(load);
        track.removeEventListener('scroll', loadRest);
      },
      { passive: true }
    );
    return track;
  }

  function firstInsitu(track) {
    return track && track.querySelector('.mobe-swipe__slide:nth-child(2) img');
  }

  function playHint(track) {
    if (hintPlayed || reduceMotion.matches || hintSeen()) return;
    hintPlayed = true;
    var img = load(firstInsitu(track));
    var ready = img && img.decode ? img.decode().catch(function () {}) : Promise.resolve();
    ready.then(function () {
      setTimeout(function () {
        var rail = track.querySelector('.mobe-swipe__rail');
        if (!rail || !rail.animate) return;
        markHint();
        // Une courbe par étape : l'aller jusqu'au tiers, le retour avec un léger
        // dépassement, puis la pose. Une courbe globale décalait le sommet.
        rail.animate(
          [
            { transform: 'translateX(0)', easing: 'cubic-bezier(0.3, 0, 0.2, 1)' },
            { transform: 'translateX(-34%)', offset: 0.45, easing: 'cubic-bezier(0.3, 0, 0.2, 1)' },
            { transform: 'translateX(3%)', offset: 0.78, easing: 'ease-out' },
            { transform: 'translateX(0)' }
          ],
          { duration: 1100 }
        );
      }, 500);
    });
  }

  var nearObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        nearObserver.unobserve(entry.target);
        load(firstInsitu(build(entry.target)));
      });
    },
    { rootMargin: '300px 0px' }
  );

  var hintObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.9) return;
        hintObserver.disconnect();
        playHint(build(entry.target));
      });
    },
    { threshold: [0.9] }
  );

  function init() {
    var items = document.querySelectorAll('#product-grid .grid__item[data-insitu]:not([data-swipe-observed])');
    items.forEach(function (item) {
      item.dataset.swipeObserved = '1';
      nearObserver.observe(item);
    });
    if (!hintPlayed && !reduceMotion.matches && !hintSeen()) {
      var target = document.querySelector('#product-grid .grid__item[data-insitu]');
      if (target) hintObserver.observe(target);
    }
  }

  function start() {
    init();
    // Les filtres et le tri remplacent la grille sans recharger la page : on la reprend.
    var container = document.getElementById('ProductGridContainer') || document.body;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        init();
      }, 100);
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
